<script setup>
import { useAuthStore } from "~/store/auth"

const props = defineProps({
  error: {
    type: Object,
    default: null,
  }
})

const loaded = ref(props.error?.statusCode !== 401)

onMounted(async () => {
  if (props.error?.statusCode === 401) {
    const authStore = useAuthStore()
    await authStore.logout()
    window.location = "/"
  }else{
    loaded.value = true
  }
})

function refresh() {
  if (props.error?.statusCode === 503) {
    window.location.reload()
  } else {
    clearError({ redirect: "/" })
  }
}
</script>


<template>
  <section v-if="loaded && props.error" class="pt-32 pb-36 bg-white overflow-hidden">
    <div class="container px-4 mx-auto">
      <div class="flex flex-col items-center flex-wrap">
        <div class="w-full md:w-1/2 p-8">
          <img class="mx-auto"
               src="/images/errors/404.png" alt="Error 404">
        </div>
        <div class="w-full md:w-1/2 p-8 text-center">
          <a
            class="inline-flex items-center text-center font-semibold text-orange-600 hover:text-orange-700 leading-normal uppercase"
            href="#" @click.prevent="refresh">
            <span>{{ props.error.statusCode === 503 ? 'Refrescar' : 'Volver a la página principal' }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
